import React from 'react'
import FarmMasterWarning from './FarmMasterWarning'
import RetrofitUnknownWarning from './RetrofitUnknownWaning'
import NoRetrofitWarning from './NoRetrofitWaning'

interface WarningContentProps {
  isFarmMaster: boolean
  isUnknown: boolean
}

/**
 * Content component for the different retrofit warning types
 */
const WarningContent: React.FC<WarningContentProps> = ({ isFarmMaster, isUnknown }) => {
  if (isFarmMaster) {
    return <FarmMasterWarning />
  }
  if (isUnknown) {
    return <RetrofitUnknownWarning />
  }

  return <NoRetrofitWarning />
}

export default WarningContent
